import { BrowserRouter, Route, Routes } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

import Server from "./pages/Server";
import Apply from "./pages/apply";
import Applys from "./pages/applys";
import Servers from "./pages/Servers";
import NotFount from "./pages/not Fount";
import Home from "./pages/Home";
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/servers" element={<Servers />} />
        <Route path="/" element={<Home />} />
        <Route path="/server/:id" element={<Server />} />
        <Route path="/server/:id/apply" element={<Apply />} />
        <Route path="/server/:id/applys" element={<Applys />} />
        <Route path="*" element={<NotFount />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
